module.exports = __webpack_public_path__ + "img/ais-fa-logo.89dbcbbc.png";